import {
  Cushion,
  FlexContainer,
  MaxWidth,
  Rectangle,
  Shadow,
  Typography,
} from '@pitchero/react-ui';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import useBreakpoint from '../../../lib/use-breakpoint';
import { Trans } from '../../../lib/i18n';
import { getIsApp } from '../../../store/common/selectors';
import { getShopCategories } from '../../../store/shop/selectors';
import SlashNavigation from '../../navigation/mobile/slash-navigation';
import SecondaryNavigationLinks from '../../navigation/secondary-navigation-links';

const FilterBar = ({ categories, selectedCategory, isApp }) => {
  // Show nothing if we are in the app and only have one category
  if (isApp && categories.length < 2) {
    return null;
  }
  const isMobile = useBreakpoint();

  if (isMobile) {
    const links = ['all', ...categories].map((category) => ({
      name: category,
      route: category === 'all' ? 'shop' : 'shop.category',
      params: { category },
      transKey: `shop:${category}`,
    }));
    return (
      <SlashNavigation
        name="shop"
        nameTransKey="shop:lading_page_title"
        activeSection={selectedCategory}
        activeSectionTransKey={`shop:${selectedCategory}`}
        items={links}
      />
    );
  }

  const links = ['all', ...categories].map((category) => ({
    name: category,
    route: category === 'all' ? 'shop' : 'shop.category',
    params: { category },
    transKey: `shop:${category}`,
  }));

  if (isMobile) {
    return (
      <SlashNavigation
        name="shop"
        nameTransKey="shop:lading_page_title"
        activeSection={selectedCategory}
        activeSectionTransKey={`shop:${selectedCategory}`}
        items={links}
      />
    );
  }

  return (
    <Shadow>
      <Rectangle fill="white">
        <Cushion component="div" vertical="medium">
          {!isApp && (
            <Cushion
              horizontal="small"
              component="div"
              responsive={[{ minWidth: 'tab', props: { horizontal: 'large' } }]}
            >
              <MaxWidth component="div" maxWidth={1366} center>
                <FlexContainer alignItems="center">
                  <Cushion right="xlarge">
                    <Typography
                      component="div"
                      preset="title"
                      color="black"
                      responsive={[{ maxWidth: 'tab', props: { align: 'center' } }]}
                    >
                      <Trans i18nKey="common:payments">Shop</Trans>
                    </Typography>
                  </Cushion>
                  <SecondaryNavigationLinks links={links} activeSection={selectedCategory} />
                </FlexContainer>
              </MaxWidth>
            </Cushion>
          )}
        </Cushion>
      </Rectangle>
    </Shadow>
  );
};

FilterBar.defaultProps = {
  selectedCategory: null,
};

FilterBar.propTypes = {
  selectedCategory: PropTypes.string,
  categories: PropTypes.arrayOf(PropTypes.string).isRequired,
  isApp: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  categories: getShopCategories(state),
  isApp: getIsApp(state),
});

export default connect(mapStateToProps)(FilterBar);
